import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const TCC_LOGO_MARK = "/tcc_logo_mark.png";

export default function LegalShell({ title, children, testId }) {
    return (
        <div className="min-h-screen bg-aq-cream text-aq-charcoal" data-testid={testId}>
            <header className="border-b border-aq-border bg-aq-cream/90 backdrop-blur">
                <div className="max-w-3xl mx-auto px-5 md:px-8 py-5 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-3" data-testid="legal-brand-link">
                        <img
                            src={TCC_LOGO_MARK}
                            alt="TheCounselCo"
                            className="w-10 h-10 object-contain"
                        />
                        <div className="leading-tight">
                            <div className="font-serif text-xl text-aq-navy">
                                Academi<span className="text-aq-gold">Q</span>
                            </div>
                            <div className="text-[10px] uppercase tracking-[0.18em] text-aq-muted">
                                by TheCounselCo
                            </div>
                        </div>
                    </Link>
                    <Link
                        to="/"
                        className="text-sm text-aq-navy inline-flex items-center gap-1.5 hover:underline"
                        data-testid="legal-back-home"
                    >
                        <ArrowLeft className="w-4 h-4" /> Back to home
                    </Link>
                </div>
            </header>

            <main className="max-w-3xl mx-auto px-5 md:px-8 py-12 md:py-16">
                <p className="text-aq-gold uppercase tracking-[0.2em] text-xs mb-3">Legal</p>
                <h1 className="font-serif text-4xl md:text-5xl text-aq-navy leading-tight mb-8">
                    {title}
                </h1>
                <article className="prose prose-aq max-w-none text-aq-charcoal [&_h2]:font-serif [&_h2]:text-aq-navy [&_h2]:text-xl [&_h2]:mt-8 [&_h2]:mb-3 [&_p]:leading-relaxed [&_p]:mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-4 [&_li]:mb-1.5 [&_a]:text-aq-gold [&_a]:underline [&_a]:underline-offset-4 [&_strong]:text-aq-navy">
                    {children}
                </article>
            </main>
        </div>
    );
}
